__turbopack_context__.v({
  "imageContainer": "social-proof-item-module-scss-module__XQvJdG__imageContainer",
  "mobileAvatarRow": "social-proof-item-module-scss-module__XQvJdG__mobileAvatarRow",
  "mobileChipOverlay": "social-proof-item-module-scss-module__XQvJdG__mobileChipOverlay",
  "mobileChipOverlayBottom": "social-proof-item-module-scss-module__XQvJdG__mobileChipOverlayBottom",
  "mobileItem": "social-proof-item-module-scss-module__XQvJdG__mobileItem",
  "mobileMediaImage": "social-proof-item-module-scss-module__XQvJdG__mobileMediaImage",
  "mobileMediaVideo": "social-proof-item-module-scss-module__XQvJdG__mobileMediaVideo",
  "testimonialContainer": "social-proof-item-module-scss-module__XQvJdG__testimonialContainer",
  "videoContainer": "social-proof-item-module-scss-module__XQvJdG__videoContainer",
});
